module.exports = __webpack_public_path__ + "img/batman.0894f67b.gif";